import React from "react";
import type { ConfigurationStatus } from "../models/types";

const STATUS_CLASS: Record<ConfigurationStatus, string> = {
  Draft: "op-status-pill op-status-pill--draft",
  Configured: "op-status-pill op-status-pill--configured",
  "Review Required": "op-status-pill op-status-pill--review",
  "CAD Required": "op-status-pill op-status-pill--cad",
  Warning: "op-status-pill op-status-pill--warning",
  Error: "op-status-pill op-status-pill--error",
  Approved: "op-status-pill op-status-pill--approved",
  Released: "op-status-pill op-status-pill--released",
};

interface OpStatusPillProps {
  status: ConfigurationStatus | string;
}

const OpStatusPill = ({ status }: OpStatusPillProps) => (
  <span className={STATUS_CLASS[status as ConfigurationStatus] || "op-status-pill op-status-pill--draft"}>
    {status}
  </span>
);

export default OpStatusPill;
